import { defineMessages } from 'react-intl';

export const installmentValueTilesContainerMessages = defineMessages({
  headline: {
    id: 'ic-atom-InstallmentValueTilesContainer-headline',
    defaultMessage: 'Wähle die gewünschten Raten',
  },
});
